import { Component, OnInit } from '@angular/core';
import { Message } from 'primeng/api';
import { Router } from '@angular/router';
import { ProfileService } from 'src/app/services/profile.service';
import { environment } from 'src/environments/environment';

@Component({
	selector: 'app-register-success',
	templateUrl: './register-success.component.html'
})
export class RegisterSuccessComponent implements OnInit {
	messages: Message[] = [];
	organizationName = environment.organizationName;
	isCompletion = false;

	constructor(private router: Router, private profileService: ProfileService) {}

	clearMessages() {
		this.messages.length = 0;
	}

	setMessage(msg: Message) {
		this.clearMessages();
		this.messages.push(msg);
	}

	ngOnInit() {
		this.isCompletion = history.state.isCompletion;
		this.profileService.registrationSuccessful = false;
	}

	onProceedToLogin() {
		this.router.navigate([ '/login' ]);
	}
}
